<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { cn } from '@/utils/shadcn/lib/utils.ts'

defineOptions({
    compatConfig: {
        MODE: 3,
    },
})

const props = defineProps<{
  class?: HTMLAttributes['class']
}>()
</script>

<template>
    <div
        data-slot="input-group"
        role="group"
        :class="cn(
            'group/input-group border-input-dark bg-input relative flex items-center w-fit rounded-md border shadow-xs transition-[color,box-shadow] outline-none',
            'h-(--input-height) min-w-0 has-[>textarea]:h-auto',

            // Variants based on alignment.
            'has-[>[data-align=inline-start]]:[&>input]:pl-2',
            'has-[>[data-align=inline-end]]:[&>input]:pr-2',
            'has-[>[data-align=block-start]]:h-auto has-[>[data-align=block-start]]:flex-col has-[>[data-align=block-start]]:[&>input]:pb-3',
            'has-[>[data-align=block-end]]:h-auto has-[>[data-align=block-end]]:flex-col has-[>[data-align=block-end]]:[&>input]:pt-3',

            // Focus state.
            'has-[[data-slot=input-group-control]:focus-visible]:border-ring/50',

            // Disabled state.
            'data-[disabled=true]:bg-input-disabled',

            // Error state.
            'has-[[data-slot][aria-invalid=true]]:ring-destructive/20 has-[[data-slot][aria-invalid=true]]:border-destructive dark:has-[[data-slot][aria-invalid=true]]:ring-destructive/40',

            props.class,
        )"
    >
        <slot></slot>
    </div>
</template>
